export function ContactChangePhoneIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_1076_18875)">
        <path
          d="M15.12 11.0044C14.0267 11.0044 12.9689 10.8267 11.9822 10.5067C11.6711 10.4 11.3244 10.48 11.0844 10.72L9.68889 12.4711C7.17333 11.2711 4.81778 9.00444 3.56444 6.4L5.29778 4.92444C5.53778 4.67556 5.60889 4.32889 5.51111 4.01778C5.18222 3.03111 5.01333 1.97333 5.01333 0.88C5.01333 0.4 4.61333 0 4.13333 0H1.05778C0.577778 0 0 0.213333 0 0.88C0 9.13778 6.87111 16 15.12 16C15.7511 16 16 15.44 16 14.9511V11.8844C16 11.4044 15.6 11.0044 15.12 11.0044Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1076_18875">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
